module.exports = __webpack_public_path__ + "static/media/CEPILLO18CERDASACERO.6f90b3c5.jpg";